import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var t=s=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",height:"1em",viewBox:"0 0 448 512"},s),{children:jsx("path",{d:"M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z",fill:"currentColor"})})),p=t;

export { p as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-Z2MWMARY.mjs.map